import script from "./room-placer.vue?vue&type=script&setup=true&lang=js"
export * from "./room-placer.vue?vue&type=script&setup=true&lang=js"

import "./room-placer.vue?vue&type=style&index=0&id=7c5973c8&lang=css"

const __exports__ = script;

export default __exports__